import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const THEMES = ["sportmingle", "dark", "light"];
const STORAGE_KEY = "sm-theme";

const ThemeContext = createContext({
  theme: "sportmingle",
  setTheme: () => {},
});

const readStoredTheme = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return THEMES.includes(stored) ? stored : "sportmingle";
  } catch {
    return "sportmingle";
  }
};

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readStoredTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* ignore quota / private mode */
    }
  }, [theme]);

  const value = useMemo(
    () => ({
      theme,
      setTheme: (next) => {
        if (THEMES.includes(next)) {
          setThemeState(next);
        }
      },
    }),
    [theme]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
